import { render, staticRenderFns } from "./ParticaCardXL.vue?vue&type=template&id=db2bdbf2&scoped=true&"
import script from "./ParticaCardXL.vue?vue&type=script&lang=ts&"
export * from "./ParticaCardXL.vue?vue&type=script&lang=ts&"
import style0 from "./ParticaCardXL.vue?vue&type=style&index=0&id=db2bdbf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2bdbf2",
  null
  
)

export default component.exports